import * as angular from 'angular';

import { ComponentDefinition, IApproval, LevelStatusWithDate } from '../../models';
import { HeadingDefinition } from '../logbookTable/HeadingDefinition';
import { ApprovalTableWidget } from './approvalTable.widget';
import { getHeadings } from './getHeadings';
import { ApprovalTableRowViewModel } from './ApprovalTableRowViewModel';

class ApprovalTableController implements angular.IComponentController {
    headings: HeadingDefinition[][];
    rows: ApprovalTableRowViewModel[];

    readonly boundData: { guid: string, results: LevelStatusWithDate[] };
    readonly item: ApprovalTableWidget;

    static $inject = ['$scope'];
    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this._$scope.$watch(() => this.item.configuration, () => {
            this.headings = getHeadings(this.item.configuration);
        }, true);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['boundData']) {
            const rows = this.boundData?.results ?? [];
            rows.forEach(r => r.canReject = false);
            this.rows = rows;
        }
    }
}

export const wtApprovalTable: ComponentDefinition = {
    componentId: 'wtApprovalTable',
    controller: ApprovalTableController,
    template: require('./approvalTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '<',
        item: '<'
    }
};